module.exports = __webpack_public_path__ + "static/media/us.d367121f.png";